
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/modeler",
      function () {
        return require("private-next-pages/modeler.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/modeler"])
      });
    }
  